<svg  viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9913 4L16.8663 2.125L17.75 3.00687L15.875 4.8825L14.9913 4ZM9 11.8125L5.875 8.71187L6.86875 7.73063L9 9.84313L13.6313 5.25L14.625 6.23688L9 11.8125Z" fill="currentColor"/>
<path d="M1.5 16.5V14.8831L5.50875 10.875L4.625 9.99062L1.5 13.1156V0.25H0.25V16.5C0.25 16.8315 0.381696 17.1495 0.616116 17.3839C0.850537 17.6183 1.16848 17.75 1.5 17.75H17.75V16.5H1.5Z" fill="currentColor"/>
</svg>
